import React from "react";
import { useAuth } from "@/lib/AuthContext";
import Layout from "@/components/Layout";
import PublicShell from "@/components/PublicShell";
import Noticias from "@/pages/Noticias";

/**
 * Noticias is the only public-readable page (for SEO/GEO).
 * Wraps with the appropriate shell based on auth state.
 */
export default function NoticiasRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white">
        <div className="font-display text-2xl uppercase tracking-wider">Cargando…</div>
      </div>
    );
  }
  if (user) {
    return <Layout><Noticias /></Layout>;
  }
  return (
    <PublicShell forcePublicNews>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Noticias />
      </div>
    </PublicShell>
  );
}
